import React, { FC } from 'react';
import classNames from 'classnames';

import IconRenderer, { IconProps } from 'ui/icons/IconRenderer';

import icon from './file-text-filled.svg';

import styles from './index.module.scss';

const IconFileTextFilled: FC<IconProps> = ({ className, style }) => (
  <IconRenderer
    iconHtml={icon}
    className={classNames(styles.icon, className)}
    style={style}
  />
);

export default IconFileTextFilled;
